import React, { createContext, useContext } from "react";

export type CustomFieldsCatalog = Record<string, string>;

const UserCustomFieldsContext = createContext<CustomFieldsCatalog>({});

export const UserCustomFieldsProvider: React.FC<{
  catalog: CustomFieldsCatalog;
  children: React.ReactNode;
}> = ({ catalog, children }) => (
  <UserCustomFieldsContext.Provider value={catalog}>
    {children}
  </UserCustomFieldsContext.Provider>
);

export const useUserCustomFields = (): CustomFieldsCatalog =>
  useContext(UserCustomFieldsContext);
